<template>
    <svg
        :width="props.width"
        :height="props.height"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
        d="M15 5.96663C14.95 5.9583 14.8917 5.9583 14.8417 5.96663C13.6917 5.92496 12.775 4.98329 12.775 3.81663C12.775 2.62496 13.7334 1.66663 14.925 1.66663C16.1167 1.66663 17.075 2.63329 17.075 3.81663C17.0667 4.98329 16.15 5.92496 15 5.96663Z"
        :stroke="iconColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        />
        <path
        d="M14.1417 12.0333C15.2834 12.225 16.5417 12.025 17.425 11.4333C18.6 10.65 18.6 9.36664 17.425 8.58331C16.5334 7.99164 15.2584 7.79163 14.1167 7.99163"
        :stroke="iconColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        />
        <path
        d="M4.9749 5.96663C5.0249 5.9583 5.08324 5.9583 5.13324 5.96663C6.28324 5.92496 7.1999 4.98329 7.1999 3.81663C7.1999 2.62496 6.24157 1.66663 5.0499 1.66663C3.85824 1.66663 2.8999 2.63329 2.8999 3.81663C2.90824 4.98329 3.8249 5.92496 4.9749 5.96663Z"
        :stroke="iconColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        />
        <path
        d="M5.83328 12.0333C4.69162 12.225 3.43328 12.025 2.54995 11.4333C1.37495 10.65 1.37495 9.36664 2.54995 8.58331C3.44162 7.99164 4.71662 7.79163 5.85828 7.99163"
        :stroke="iconColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        />
        <path
        d="M10 12.1917C9.95002 12.1834 9.89169 12.1834 9.84169 12.1917C8.69169 12.1501 7.77502 11.2084 7.77502 10.0417C7.77502 8.85006 8.73336 7.89172 9.92502 7.89172C11.1167 7.89172 12.075 8.85839 12.075 10.0417C12.0667 11.2084 11.15 12.1584 10 12.1917Z"
        :stroke="iconColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        />
        <path
        d="M7.57498 14.8167C6.39998 15.6 6.39998 16.8833 7.57498 17.6667C8.90831 18.5583 11.0916 18.5583 12.425 17.6667C13.6 16.8833 13.6 15.6 12.425 14.8167C11.1 13.9333 8.90831 13.9333 7.57498 14.8167Z"
        :stroke="iconColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        />
    </svg>
</template>
<script setup>
import { defineProps, inject } from 'vue';

const $filters = inject('$filters');

const props = defineProps({
    color: {
        type: String,
        default: null,
    },
    width: {
        type: Number,
        default: 20,
    },
    height: {
        type: Number,
        default: 20,
    },
});

const iconColor = props.color || $filters?.iconColor?.() || 'rgb(var(--locumate-clr-text))';
</script>
